import { render } from "./GradBook.vue?vue&type=template&id=7f49c210&scoped=true"
import script from "./GradBook.vue?vue&type=script&lang=js"
export * from "./GradBook.vue?vue&type=script&lang=js"

import "./GradBook.vue?vue&type=style&index=0&id=7f49c210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f49c210"]])

export default __exports__